import { Component, OnInit } from '@angular/core';
import { InfoBannersService } from '../../shared/info-banners.service';

@Component({
  selector: 'app-discount-banner',
  templateUrl: './discount-banner.component.html',
  styleUrls: ['./discount-banner.component.css']
})
export class DiscountBannerComponent implements OnInit {

  public banner: any;
  public time = {
    days: 0,
    hours: 0
  };

  constructor(
    private infoBanners: InfoBannersService
  ) {
    infoBanners.banners.map(banners => banners.trial_discount_banner).subscribe(banner => {
      if (banner) {
        this.banner = banner;
        this.time = this.getTime(banner.data.time_left);
      }
    });
  }

  private getTime(time) {
    let delta = time;
    const days = Math.floor(delta / 86400);
    delta -= days * 86400;
    const hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;
    return {
      days,
      hours
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/discount-banner/discount-banner.component.ts